import { envHelper } from './env';
import { getCookie, stringify } from './utils';

/**
 * atta 上报：https://atta.woa.com/#/dataManage/myData/apiHelp?attaid=00600064739
 * 鹰眼查询平台：http://log2.oa.com/mylog/logInfo/lid/106063
 */
export const attaReport = (info: { api: string; errCode: number; errMsg: string }) => {
  const openid = getCookie('yyb_openid')
    || getCookie('mobileqopenid')
    || getCookie('vqq_openid')
    || getCookie('openid')
    || '';
  const baseInfo = {
    attaid: '00600064739',
    token: '7615189212',
    platform: envHelper.platform,
    channel: envHelper.channel,
    ua: window.navigator.userAgent,
    cookies: `openid=${openid}`,
  };
  const image = new Image();
  image.src = `//h.trace.qq.com/kv?${stringify({
    ...baseInfo,
    ...info,
  })}&_dc=${Math.random()}`;
};

/**
 * 上报，方法装饰器工厂
 * @param target 被装饰的方法所在对象的原型
 * @param fnName 方法名称
 * @param fnDescriptor 方法的属性描述符
 */
export function report(api: string) {
  return (target: Object, fnName: string, _fnDescriptor: PropertyDescriptor): PropertyDescriptor => {
    const fnDescriptor = _fnDescriptor;
    const fn = fnDescriptor.value;

    fnDescriptor.value = async function (...args: any[]) {
      const result = await fn.apply(this, args);

      // 对调用方法做判断，有可能在方法中调用另一个方法，此时内层方法不做上报
      if (api === fnName) {
        // 上报
        attaReport({
          api,
          errCode: result?.errCode || 0,
          errMsg: result?.errMsg || '',
        });
      }

      return result;
    };
    return fnDescriptor;
  };
}
